import { takeLatest, call, put } from 'redux-saga/effects';
import axios from '../axiosConfig';
import { sendCustomerQuerySuccess, sendCustomerQueryRequest } from '../../slices/user';

function* sendCustomerQueryWorker({
  payload: { customerName, customerEmail, phoneNumber, message, resultsPage },
}) {
  try {
    const url = '/email/user/sendQuery';
    const config = {
      method: 'POST',
      url,
      data: JSON.stringify({
        customerName,
        customerEmail,
        phoneNumber,
        message,
        resultsPage,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);
    yield put(sendCustomerQuerySuccess({ error: data ? null : 'Problem in sending request!' }));
  } catch (error) {
    yield put(sendCustomerQuerySuccess({ error: 'Problem in sending request!' }));
    console.error(error);
  }
}

function* sendCustomerQueryWatcher() {
  yield takeLatest(sendCustomerQueryRequest.toString(), sendCustomerQueryWorker);
}

export default sendCustomerQueryWatcher;
